<template>
    <div class="head fx f_a_c f_j_sb fs_01">
      <div class="head_left">
        <img src="@/assets/computer/shouye/LOGO1.png">
      </div>
      <div class="head_right fx " >
        
        <div class=" one fx fs_01" v-for="(item,index) in headlist"  @mouseenter="mouseenter(index)" @mouseleave="mouseleave(index)">
            <div class="one_title">
                <!-- 标题 -->
                <div class="tc cursor" @click="itemClick(index)"
                     style="height:0.55rem;line-height: 0.75rem;">
                     {{ item.title }}
                </div>
                
                <div class="dixian" v-if="item.isShow"></div>
                <div class="xuanfu"></div>
                <!-- 关于我们 -->
                <div class="one_c cursor" v-if="itemindex == 1 &&item.isShow &&index==1">
                    <div class="sanjiaoxing"></div>
                    <div class=" one_item fx f_a_c" v-for="(item1,index1) in item.list1" @click="oneClick(index,index1)">
                        <img :src="item1.img" class="one_img">
                        <div class="color1 ">{{ item1.text1}}</div> 
                    </div>
                </div>
                <!-- 主营事业 -->
                <div class="three_c cursor color1" v-if="itemindex == 2 &&item.isShow &&index==2">
                      <div class="sanjiaoxing"></div>

                      <div class="three_item " v-for="(item1,index1) in item.list1">
                          <div class="fx fa_s pb01">
                              <img :src="item1.img" class="one_img">
                              <div class="three_text1">
                                <div class="pb_008" @click="syClick_o(index1)"> {{ item1.text1}} </div> 
                                <div v-for="(item2,index2) in item1.twoL">
                                    <div class="pb_008 fs_0075 color8"  @click="syClick_t(index1,index2)"><span class="fw_8">·</span> {{ item2.text2 }}</div>
                                    <div class="fx_l " >
                                      <div class="threeL_text color9" @click="syClick_te(index1,index2,index3)"  v-for="(item3,index3) in item2.threeL">{{ item3 }}</div>
                                    </div>
                                </div>
                              </div>
                          </div>
                      </div>
                </div>
                <!-- 案例分享 -->
                <div class="five_c cursor color1" v-if="itemindex == 3 &&item.isShow &&index==3">
                    <div class="sanjiaoxing"></div>
                    <div class="three_item " v-for="(item1,index1) in item.list1">
                        <div class="fx fa_s pb_004">
                            <img :src="item1.img" class="one_img">
                            <div class="three_text1">
                              <div class="pb_008" @click="alClick_o(index1)"> {{ item1.text1}} </div> 
                              <div v-for="(item2 , index2) in item1.twoL">
                                  <div class="pb_004 fs_007 color8" @click="alClick_t(index1,index2)"> {{ item2.text2 }}</div>
                                  <div class="fx_l " >
                                    <div class="threeL_text color9" @click="alClick_te(index1,index2,index3)" v-for="(item3,index3) in item2.threeL">{{ item3 }}</div>
                                  </div>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
</template>

<script setup>
  import { useRouter } from 'vue-router'
  import { ref , onMounted} from 'vue'
  const router = useRouter()

 
const emits = defineEmits(["FatherClick"]);

  onMounted(() => {
    
  })
  const itemClick =(e)=>{
      if (e==0) {
        router.push({path:'/home'})
      }else if(e==1){
        router.push({path:'/summary',query:{index1:0}})
      }else if(e==2){
        router.push({path:'/mainbusiness',query:{index1:0,index2:0,index3:0}})
      }else if(e==3){
        router.push({path:'/ClassicCases',query:{index1:0,index2:0}})
      }else if(e==5){
        router.push({path:'/contactus'})
      }else if(e==4){
        router.push({path:'/Journalism'})
        emits("FatherClick");
      }
  }
  const syClick_o = (a)=>{
      router.push({path:'/mainbusiness',query:{index1:a,index2:0,index3:0}})
  }
  const syClick_t = (a,b)=>{
      router.push({path:'/mainbusiness',query:{index1:a,index2:b,index3:0}})
  }
  const syClick_te = (a,b,c)=>{
      router.push({path:'/mainbusiness',query:{index1:a,index2:b,index3:c}})
  }
  const alClick_o = (a)=>{
      router.push({path:'/ClassicCases',query:{index1:a}})
  }
  const alClick_t = (a,b)=>{
      router.push({path:'/ClassicCases',query:{index1:a,index2:b,}})
  }
  const alClick_te = (a,b,c)=>{
      router.push({path:'/ClassicCases',query:{index1:a,index2:b,index3:c}})
  }
  const oneClick=(index,index1)=>{
    router.push({path:'/summary',query:{index1:index1}})
  }
  onMounted(() => {

  });
  const headlist = ref([])
  headlist.value = [
    {
        type:1,
        title:'首页',
        isShow:false,
        list1:[]
    },{
        type:1,
        title:'公司简介',
        isShow:false,
        list1:[
            {
                text1:'公司介绍',
                img:require('@/assets/computer/shouye/1-1.png'),
                img1:require('@/assets/computer/shouye/1-1h.png'),
            },{
                text1:'文化理念',
                img:require('@/assets/computer/shouye/1-2.png'),
                img1:require('@/assets/computer/shouye/1-2h.png'),
            },{
                text1:'核心优势',
                img:require('@/assets/computer/shouye/1-3.png'),
                img1:require('@/assets/computer/shouye/1-3h.png'),
            },{
                text1:'发展历程',
                img:require('@/assets/computer/shouye/1-4.png'),
                img1:require('@/assets/computer/shouye/1-4h.png'),
            },{
                text1:'公司荣誉',
                img:require('@/assets/computer/shouye/1-5.png'),
                img1:require('@/assets/computer/shouye/1-5h.png'),
            },
        ]
    },{
        type:1,
        title:'主营业务',
        isShow:false,
        list1:[
            {
                text1:'数字多媒体+智慧展厅事业部',
                img:require('@/assets/computer/shouye/3-1.png'),
                img1:require('@/assets/computer/shouye/3-1h.png'),
                twoL:[
                    {
                        text2:'数字展厅设计、多媒体、实施一体化服务',
                        threeL:[]
                    }, {
                        text2:'数字多媒体交互方式，打造沉浸式数字新体验',
                        threeL:['沉浸空间' , '数智元宇宙','全息屏幕','互动投影','创意触屏','VR/AR体验','数字内容']
                    }
                ]
            },{
                text1:'信息化技术软件开发事业部',
                img:require('@/assets/computer/shouye/3-2.png'),
                img1:require('@/assets/computer/shouye/3-2h.png'),
                twoL:[
                    // {
                    //     text2:'数字信息化·数据可视化',
                    //     threeL:[]
                    // },{
                    //     text2:'成熟软件平台赋能',
                    //     threeL:['VR+展览展示','VR+政务信息化','VR+智能制造','VR+教育培训']
                    // },
                ]
            },
        ]
    },{
        type:1,
        title:'经典案例',
        isShow:false,
        list1:[
            {
                text1:'数智展览展示',
                img:require('@/assets/computer/shouye/5-1.png'),
                img1:require('@/assets/computer/shouye/5-1h.png'),
                twoL:[]
            },{
                text1:'软件开发',
                img:require('@/assets/computer/shouye/5-2.png'),
                img1:require('@/assets/computer/shouye/5-2h.png'),
                twoL:[
                  {
                      text2:'VR+GIS',
                      threeL:[]
                  },{
                      text2:'VR+展览展示',
                      threeL:[]
                  },{
                      text2:'VR+教育、培训',
                      threeL:[]
                  },{
                      text2:'VR+工业互联网',
                      threeL:[]
                  },
                ]
            }
        ]
    },{
        type:1,
        title:'新闻资讯',
        isShow:false,
        list1:[]
    },{
        type:1,
        title:'联系我们',
        isShow:false,
        list1:[]
    },
  ]
  const mouseenter = (e)=>{
    listblean(e)
  }
  const mouseleave = (e)=>{
    listblean(e)
  }
  const listblean=(e)=>{
    itemindex.value=e
    let list = []
    headlist.value.forEach((element,index) => {
      if (e==index) {
        element.isShow =  !element.isShow
      }
      list.push(element)
    });
    headlist.value=list
  }
  const itemindex = ref(0)

  window.addEventListener("scroll", function () {
    let list = []
      headlist.value.forEach((element,index) => {
        element.isShow = false
        list.push(element)
      });
      headlist.value=list
  });
</script>

<style scoped>

  .head{
    width: 88%;
    height: 0.55rem;
    padding: 0 6%;
    /* line-height: 0.55rem; */
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 4;
  }
  .head_left img{
    width: 1.5rem;
    height: auto;
  }
  .xuanfu{
    width: 100%;
    height: 0.2rem;
    /* background-color: #000000; */
  }
  .dixian{
    width: 100%;
    border: 0.02rem solid red;
    position: absolute;
    bottom: 0.1rem;
  }
  .one{
    width: 0.8rem;
  }
  .one_itme{
    background-color: black;
  }
  .one_img{
    width: 0.08rem;
    height: 0.08rem;
    margin-right: 0.05rem;
  }
  .one_title{
    width: 100%;
    
    position: relative;
  }
  .one_c{
    width: 0.52rem;
    position: absolute;
    top: 0.71rem;
    left: 0.07rem;
    background-color: #fff;
    padding: 0.07rem 0.08rem;
  }
  .sanjiaoxing{
    width: 0;
    height: 0;
    border-top: 0.05rem solid transparent; 
    border-right: 0.05rem solid transparent;
    border-left: 0.05rem solid transparent;
    /* border-bottom: 0.05rem solid orangered; */
    border-bottom: 0.05rem solid rgb(255, 255, 255);
    position: absolute;
    top:  -0.09rem;
    left: 42%;
  }
  .one_item{
    height: 0.2rem;
    font-size: 0.088rem;
  }
  .three_c{
    width: 2.3rem;
    position: absolute;
    top: 0.71rem;
    left: -0.67rem;
    background-color: #fff;
    padding: 0.13rem 0.08rem 0.05rem;
    font-size: 0.088rem;
  }
  .three_item{
    width: 100%;
    /* height: 0.2rem; */
  }

  .twoL{
    width: 100%;
    height: 0.1rem;
    font-size: 0.07rem;
  }
  .twoL_text{
    height: 0.1rem;
  }
  .three_text{
    font-size: 0.05rem;
  }
  .three_o_text{
    height: 0.2rem;
    line-height: 0.2rem;
  }
  .threeL_text{
    /* width: 25%; */
    font-size: 0.065rem;
    padding: 0.01rem 0.08rem 0.06rem;
  }
  .five_c{
    width: 0.82rem;
    position: absolute;
    top: 0.71rem;
    left: -0.05rem;
    background-color: #fff;
    padding: 0.07rem 0.08rem;
  }
</style>
